"use client";

import { useStaffReviewPresence } from "@/lib/review-concurrency/useStaffReviewPresence";

export function useMakeupReviewPresence(
  makeupSessionId: string | null,
  isActive: boolean,
): { presenceSupported: boolean } {
  return useStaffReviewPresence(
    makeupSessionId ? { kind: "makeup-session", id: makeupSessionId } : null,
    isActive,
  );
}
